export default {
  estaCarregando: false,
  lista: [],
  resumo: [],
  parametros: '',
  filtros: {
    instrutor: null
  }
}
